mySmApp.directive('supplierRating', ["entityFactory", "$http", "$rootScope", "$q", "$compile", "formService", "$uibModal", "contractTemplateService", "dataManipulationService", "listService", "$injector", "invoiceService", "$timeout", function (entityFactory, $http, $rootScope, $q, $compile, $formService, $modal, contractTemplateService, $dataManipulationService, listService, $injector, invoiceService, $timeout) {
    return {
        restrict: 'AE',
        templateUrl: $rootScope.createHtmlUrl("ui2.0/supplierRating.html"),
        scope: true,
        link: function (scope, element, attrs, controller) {
            scope.getSupplierRating = function(value, elem){
                if(scope.listingCalled){
                    scope.listingCalled = false;
                    return;
                }
                var apiUrl= "/supplierScore/getScoreAndEntityCount";
                var classstr = '.jx_'+value.id;

                scope.colorMapper ={1:'yellow',2:'red',3:'green'};
                if( scope.activeSupplier== value.id){
                    scope.activeSupplier = null;
                }else if( scope.tempRatingData && scope.tempRatingData[value.id] == scope.ratingData){
                    scope.activeSupplier = value.id;
                } else{
                    $("#ajaxcalloading").show();
                    scope.ratingDataToPost = {
                        "supplierId": value.id,//TODO check and change
                        "filterMap": {
                            "61": {
                                "entityTypeId": 61,
                                "offset": 0,
                                "size": 20,
                                "orderByColumnName": "id",
                                "orderDirection": "desc nulls last",
                                "filterJson": {
                                    "1": {
                                        "multiselectValues": {
                                            "SELECTEDDATA": scope.data.suppliers.values.filter( supp => supp.id == value.id)
                                        },
                                        "filterId": 1,
                                        "filterName": "supplier",
                                        "entityFieldHtmlType": null,
                                        "entityFieldId": null
                                    },
                                    "17": {
                                        "multiselectValues": {
                                            "SELECTEDDATA": scope.data.functions.values
                                        },
                                        "filterId": 17,
                                        "filterName": "functions",
                                        "entityFieldHtmlType": null,
                                        "entityFieldId": null
                                    },
                                    "18": {
                                        "multiselectValues": {
                                            "SELECTEDDATA": scope.data.services.values
                                        },
                                        "filterId": 18,
                                        "filterName": "services",
                                        "entityFieldHtmlType": null,
                                        "entityFieldId": null
                                    }
                                },
                            },
                            "28": {
                                "entityTypeId": 28,
                                "offset": 0,
                                "size": 20,
                                "orderByColumnName": "id",
                                "orderDirection": "desc nulls last",
                                "filterJson": {
                                    "1": {
                                        "multiselectValues": {
                                            "SELECTEDDATA": scope.data.suppliers.values.filter( supp => supp.id == value.id)
                                        },
                                        "filterId": 1,
                                        "filterName": "supplier",
                                        "entityFieldHtmlType": null,
                                        "entityFieldId": null
                                    },
                                },
                                "isWorkflowOpen":true
                            },
                            "17": {
                                "entityTypeId": 17,
                                "offset": 0,
                                "size": 20,
                                "orderByColumnName": "id",
                                "orderDirection": "desc nulls last",
                                "filterJson": {
                                    "1": {
                                        "multiselectValues": {
                                            "SELECTEDDATA": scope.data.suppliers.values.filter( supp => supp.id == value.id)
                                        },
                                        "filterId": 1,
                                        "filterName": "supplier",
                                        "entityFieldHtmlType": null,
                                        "entityFieldId": null
                                    },
                                },
                                "isWorkflowOpen":true
                            }
                        }
                    }
                    scope.activeSupplier = value.id;
                    $http.post(apiUrl,  scope.ratingDataToPost).then(function (response) {
                        scope.ratingData= response.data;
                        scope.ratingData.contractData = scope.ratingData.listCountData.find(data => data.listId == 2);
                        scope.ratingData.disputeData = scope.ratingData.listCountData.find(data => data.listId == 286);
                        scope.ratingData.issueData = scope.ratingData.listCountData.find(data => data.listId == 8);
                        if(! scope.tempRatingData){
                            scope.tempRatingData = {};
                        }
                        scope.tempRatingData[value.id] = response.data;
                        var width = scope.ratingData.supplierScore.split(":;")[1]+'%';
                        $(".icon-Favourite-Selected").width(width);
                        $("#ajaxcalloading").hide();
                    });
                }
            };
            scope.openSupplierRatingList = function(obj){
                //function and service value from scope .data
                scope.alwaysShowCheckbox = false;
                if(obj.listId == 2){
                    scope.alwaysShowCheckbox = true;
                }
                scope.listingCalled= true;
                if(obj.count>0) {
                    scope.activeSupplier = null;
                    scope.popupList = [
                        {
                            "id": 3505,
                            "label": obj.label,
                            "type": "titledBox",
                            "orderSeq": 40,
                            "properties": {},
                            "fields": [
                                {
                                    "id": 11001,
                                    "listId": obj.listId,
                                    "layoutURL": "/listRenderer/list/" + obj.listId + "/defaultUserListMetaData/",
                                    "orderSeq": 1100,
                                    "properties": {},
                                    "displayMode": "display",
                                    "dataURL": "/listRenderer/list/" + obj.listId + "/listdata/",
                                    "dynamicField": false,
                                    "autoComplete": false,
                                    "enableListView": false,
                                    "bulkEditable": false
                                }
                            ]
                        }
                    ]
                    scope.listModal = $modal.open({
                        templateUrl: $rootScope.createHtmlUrl("ui2.0/globalListPopup.html"),
                        size: "lg",
                        backdrop: "static",
                        keyboard: false,
                        modalFade: true,
                        scope: scope,
                        windowClass: "clonepopup globalListPopup delegation_create supplier-rating",
                        resolve: {}
                    });
                    scope.listModal.rendered.then(function () {
                        var scopeTemp = $(" [my-table]").scope();
                        if (scopeTemp.deferredInstance) {
                            scopeTemp.deferredInstance.resolve("Initiated");
                            scopeTemp.deferredInstance.promise.then(function () {
                                if (!scopeTemp.dataTable && scopeTemp.deferred && scopeTemp.deferred.promise) {
                                    scopeTemp.deferred.promise.then(function () {
                                        !scopeTemp.metadatasearchPage && scopeTemp.$broadcast("initializeTable");
                                    });
                                }
                            });
                        }
                    })
                }
            }
            scope.closeRatingPopup= function(){
                scope.listModal.close();
            }
            scope.linkSupplierRatingEntities = function() {
                var checkList = $("input.masterSlaListJson:checked");
                var listObj = [];
                $(checkList).each(function (index, item) {
                    listObj.push({"entityId": Number($(item).val()), "entityTypeId": 61}) //TODO replace from variable
                });
                if (listObj.length) {
                    scope.linkedObj = {
                        "entityId": scope.data.id.values,
                        "entityTypeId": scope.data.entityTypeId.values,
                        "linkEntities": listObj
                    };
                    console.log(scope.linkedObj);
                    var apiUrl = "/linkentity/link";
                    $http.post(apiUrl, scope.linkedObj).then(function (response) {
                        if (!response.data.error) {
                            SirionUtils.openSirionDialogs({popupType: 'alert', str: "Linked successfully.", heading: intl_msg[24153],yesCbFn: "closeRatingPopup",yesName: "OK"});
                        }
                    });
                }
            }

            scope.closeSupplierRating = function() {
                scope.activeSupplier = null;
            }
        }
    }
}]);

